import s from './Deal.scss'
import { FaPen, FaCopy, FaTrash } from 'react-icons/fa'
import cn from 'classnames'
import { isOnlyTimetracker } from 'utils/authService'

const Deal = ({ deal, onEdit, onDelete, onClone }) => {
  return (
    <div
      className={cn(s.deal, {
        [s.timeOff]: !deal.dealId
      })}
      key={deal.id}
    >
      <div className={s.flex}>
        <span>
          <span className={s.bold}>{deal.hours} hrs</span>
          {deal.clients.length === 0 &&
            (deal.billable ? (
              <span className={s.billable}> - bill</span>
            ) : (
              <span className={s.nonBillable}> - non-bill</span>
            ))}
        </span>
        <div>
          <FaPen className={s.icon} onClick={onEdit} />
          <FaCopy className={s.icon} onClick={onClone} />
          <FaTrash className={s.icon} onClick={onDelete} />
        </div>
      </div>
      {deal.dealId ? (
        <>
          <div style={{ textDecoration: 'underline', marginBottom: 5 }}>
            {deal.clients.length === 0
              ? deal.typeOfWork.name
              : deal.clients.map(client => client.workType).join(' | ')}
          </div>
          <div className={s.bold}>
            {isOnlyTimetracker() ? (
              deal.projectNumber ? (
                deal.projectNumber + ' - ' + deal.name
              ) : (
                deal.name
              )
            ) : (
              <a href={`/opportunities/${deal.dealId}`} target="_blank" rel="noreferrer">
                {deal.projectNumber ? deal.projectNumber + ' - ' : ''} {deal.name}
              </a>
            )}
          </div>
          <div className={s.clients}>
            {deal.clients.map(client => (
              <div key={client.name} className={s.client}>
                <span>{client.hours}h</span> {client.billable ? 'bill' : 'non-bill'}{' '}
                <span>{client.name}</span>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div style={{ textDecoration: 'underline' }}>Time Off - {deal.timeOffType?.name ?? ''}</div>
      )}
    </div>
  )
}

export default Deal
